<template>
    <div class="search-container">
            <p-input 
                :placeholder="placeHolder" 
                v-model="filters.automatic"
                @input="doSearchDebounce"/>
            <slot name="headerRow"></slot>
            <div class="scrollable-container">
                <draggable
                    :list="mutableSearchData"
                    :move="onDragMove"
                    :group="{ name: group, pull: 'clone', put: false }"
                    class="list-group"
                    style="max-height: 450px"
                    item-key="sku"
                    :disabled="disableDrag">
                    <template #item="{ element: item }">
                        <div>
                            <div
                                :class="{ 'selected': selectedItem === item }"
                                @mousedown="selectRow(item)"
                                @click="selectRow(item)">
                                    <slot name="itemText" :value="item.text" :item="item">
                                        {{ item.text }}
                                    </slot>
                            </div>
                        </div>
                    </template>
                </draggable>
            </div>      
            <b-row class="footercontainer">
                 <b-col>
                    <div class="mt-2 text-nowrap">{{ totalRows }} Results</div>
                </b-col>
                <b-col style="padding-left: 0px;">
                    <b-pagination
                        v-model="filters.currentPage"
                        :total-rows="totalRows"
                        :per-page="filters.perPage"
                        :limit="10"
                        class="mt-1"
                    ></b-pagination>
                </b-col>               
            </b-row>      
        </div>
  </template>
  
  <script>
    import draggable from "vuedraggable";
    import baseInputs from '@/components/mixins/BaseInputs';
    import selectListOptionsDataContext from '@/services/selectListOptions.dataContext.js';
    import axios from 'axios'
    import debounce from 'lodash/debounce';
  
    export default {
        name: "ProductDraggableSearch",
        components: { draggable },
        mixins: [baseInputs],
        props: {
            value: [Array],
            placeHolder: {
                type: String,
                default: "Search products..."
            },
            endPoint: {
                type: String
            },
            enableNodeDragToRoot: {
                type: Boolean,
                default: false
            },
            persistentResults: {
                type: Boolean,
                default: true
            },
            group: {
                type: String,
                default: "items"
            },
            disableDrag: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                mutableSearchData: [Array],
                doSearchDebounce: null,
                totalRows: 0,
                filters: {            
                    automatic: '',
                    perPage: 100,
                    locationId: null,
                    currentPage: 1,
                },
                dragging: false,
                selectedItem: null
            };
        },
        watch: {
            value: {
                handler: function(newVal) {
                    this.mutableSearchData = newVal;
                }
            },
            'filters.currentPage': 'doSearch',
        },
        methods: {
            doSearch(){
                return axios
                    .post(this.endPoint, this.filters)
                    .then(resp => {
                        this.totalRows = resp.data.count;
                        if(!resp.data.data)
                        {
                            this.mutableSearchData = [];
                            return;
                        }
                        this.mutableSearchData = [...resp.data.data];                        
                    });
            },        
            onDragMove(event){
                if(!this.enableNodeDragToRoot)
                {
                    let currentNode = event.related;

                    // Get the level by counting the number of parent elements (ul) up the chain
                    let level = 0;

                    // Traverse up the DOM tree to count levels
                    while (currentNode && !currentNode.classList?.contains('tree-container')) {
                        if (currentNode.tagName === 'UL') {
                            level++;
                        }
                        currentNode = currentNode.parentNode;
                    }

                    // Prevent moving to root if it's a file/folder without children
                    if (level === 1) {
                        return false; // Block the drop
                    }
                }
                return true;
            },
            selectRow(item)
            {
                this.selectedItem = item;
                this.$emit('item-selected', item)
            }
        },
        async mounted() {
            this.doSearchDebounce = debounce(this.doSearch, 500);
            this.filters.locationId = await selectListOptionsDataContext.getSelectedLocationIdAsync();
            this.mutableSearchData = this.value;
        }
  };
  </script>
  
  <style scoped lang="scss">
    .search-container {
        height: 100%;
    }

    .scrollable-container {
        height: 80%;
        overflow-y: auto;
        overflow-x: hidden;
        border: 1px solid rgba(0, 0, 0, 0.12);
    }

    .footercontainer {
        flex-wrap: nowrap !important;
        padding-top: 5px;
    }
    :deep(.list-item ) {
        padding: 10px;
        border: 1px solid #ddd;
        margin: 5px 0;
        cursor: pointer;
    }

    :deep(.selected ) {
        background: rgba(0, 0, 0, 0.12) !important;
        border-color: #ddd !important;
    }

    :deep(.pagination ) {
        float: right;
    }
  </style>